export const Divider = () => {
  return (
    <div className="x-full flex py-onepulse" data-testid="separator">
      <div
        className="flex-1 border-border-neutral border-hairline"
        data-testid="divider-line"
      />
    </div>
  )
}
